import React, { useState, useEffect, useRef } from 'react';
import {
  useNavigate
} from 'react-router-dom';

import application from 'application';

import useOnClickOutside from 'generics/hooks/on-click-outside';

import { executeInSequence } from 'utilities';

import QuickAccess from '../quick-access';

import internalEventCodes from 'event-system/codes/internal';

import { ReactComponent as MenuIcon } from 'assets/images/menu-icon.svg';
import { ReactComponent as CloseIcon } from 'assets/images/close-button-icon.svg';
import { ReactComponent as BackArrowIcon } from 'assets/images/back-arrow-icon.svg';

import { useSwipeRightListener } from './swipe-right-hook';

import './index.scss';

const QUICK_ACCESS_DRAWER_WIDTH = '80px';
const QUICK_ACCESS_DRAWER_PADDING = '10px';

function MobileHeader(props) {

  const startup = props.startup;
  const activateStartup = props.activateStartup;

  const navigate = useNavigate();

  const quickAccessDrawerReference = useRef(null);

  const [rootState, setRootState] = useState({
    displayBackButton: false,
    previousPath: null
  });

  useOnClickOutside(quickAccessDrawerReference, closeQuickAccessDrawer);

  useEffect(function onLoad() {

    const unlisteners = executeInSequence([
      listenToStateChangeEvent
    ]);

    return function onUnload() {
      executeInSequence(unlisteners);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useSwipeRightListener({ current: document.body }, handleSwipeRight);

  function handleSwipeRight() {

    if (rootState.displayBackButton === false) {
      return;
    }

    handleBackButtonClick();

  }

  function listenToStateChangeEvent() {

    function updateState(state) {

      setRootState(function updateRootState(rootState) {

        return {
          ...rootState,
          ...state
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.UPDATE_MOBILE_HEADER_STATE, updateState);

    return function unlistenEnableBodyScrollEvent() {

      application.eventSystem.internal.off(internalEventCodes.UPDATE_MOBILE_HEADER_STATE, updateState);

    };

  }

  function openQuickAccessDrawer(event) {

    event.stopPropagation();

    const element = quickAccessDrawerReference.current;

    if (element === null) {
      return;
    }

    element.style.width = QUICK_ACCESS_DRAWER_WIDTH;
    element.style.padding = QUICK_ACCESS_DRAWER_PADDING;

  }

  function closeQuickAccessDrawer() {

    const element = quickAccessDrawerReference.current;

    if (element === null) {
      return;
    }

    element.style.width = 0;
    element.style.padding = 0;

  }

  function handleBackButtonClick() {

    let previousPath = rootState.previousPath;

    if (previousPath === null) {
      previousPath = -1;
    }

    navigate(previousPath);
    application.smallScreenManagement.backToMiddlePanel();

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        displayBackButton: false,
        previousPath: null
      };

    });

  }

  function renderQuickAccess(onOptionClick = function noop() {}) {

    if (startup == null) {
      return;
    }

    const quickAccessProps = {
      startup,
      activateStartup,
      onOptionClick
    };

    return <QuickAccess {...quickAccessProps} />;

  }

  function renderQuickAccessDrawer() {

    const quickAccessDrawerContainerAttributes = {
      ref: quickAccessDrawerReference,
      id: 'quick-access-drawer-container'
    };

    const closeQuickAccessDrawerControlAttributes = {
      className: 'quick-access-drawer-close-control',
      onClick: closeQuickAccessDrawer
    };

    return <div {...quickAccessDrawerContainerAttributes}>

      <div className='quick-access-drawer-header'>
        <button {...closeQuickAccessDrawerControlAttributes}>
          <CloseIcon />
        </button>
      </div>

      {renderQuickAccess(closeQuickAccessDrawer)}
    </div>;

  }

  function renderLeadingControl() {

    if (rootState.displayBackButton === true) {

      const backControlAttributes = {
        className: 'startup-menu-control',
        'aria-label': 'Back',
        onClick: handleBackButtonClick
      };

      return <button {...backControlAttributes}>
        <BackArrowIcon className='startup-header-back-icon' />
      </button>;

    }

    const startupMenuControlAttributes = {
      className: 'startup-menu-control',
      onClick: openQuickAccessDrawer
    };

    return <button {...startupMenuControlAttributes}>
      <MenuIcon className='startup-header-menu-icon' />
    </button>;

  }

  function tryRenderAssistantOpenControl() {

    if (props.assistantAvailable === false) {
      return;
    }

    const assistantOpenControlAttributes = {
      className: 'assistant-open-control',
      onClick: props.onAssistantOpen
    };

    return <button {...assistantOpenControlAttributes}>
      <img src="https://app-assets.venturz.co/assets/images/ask-ai-medium-icon.svg" width={24} height={24} alt="Assistant" />
    </button>;

  }

  function tryRenderDefaultView() {

    return <div id="startup-main-static-mobile-header-default-view">
      {renderLeadingControl()}

      <h4 className='startup-header-label ellipsis'>{startup.name}</h4>

      {tryRenderAssistantOpenControl()}

      {renderQuickAccessDrawer()}
    </div>;

  }

  function renderMain() {

    return <div id='startup-main-static-mobile-header'>

      {tryRenderDefaultView()}

    </div>;

  }

  return renderMain();

}

export default MobileHeader;